import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initLocale } from "@/lib/locale";
import { bindDocumentPrefs } from "@/lib/prefs";
import { startServiceWorker } from "@/lib/push";
import { queryClient } from "./query-client";
import { router } from "./router";
import "@/styles/app.css";

bindDocumentPrefs();
initLocale();
startServiceWorker((href) => void router.navigate({ href }));

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
